import { useEffect, useRef, useState } from 'react';
import { supabase } from '../lib/supabase';

const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:3300/ws';

export const useWebSocket = (onMessage) => {
  const wsRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const reconnectTimeoutRef = useRef(null);
  const onMessageRef = useRef(onMessage);

  // Atualizar ref quando onMessage mudar
  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);

  useEffect(() => {
    const connect = async () => {
      try {
        // Obter token JWT do Supabase
        const { data: { session } } = await supabase.auth.getSession();
        const token = session?.access_token;

        if (!token) {
          console.warn('[WebSocket] Sem token de autenticação');
          return;
        }

        // Conectar ao WebSocket com token
        const ws = new WebSocket(`${WS_URL}?token=${token}`);
        wsRef.current = ws;

        ws.onopen = () => {
          setIsConnected(true);
        };

        ws.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            if (onMessageRef.current) {
              onMessageRef.current(data);
            }
          } catch (err) {
            console.error('[WebSocket] Erro ao processar mensagem:', err);
          }
        };

        ws.onerror = (error) => {
          console.error('[WebSocket] Erro:', error);
        };

        ws.onclose = (event) => {
          setIsConnected(false);

          // Tentar reconectar após 5 segundos
          reconnectTimeoutRef.current = setTimeout(() => {
            connect();
          }, 5000);
        };

      } catch (err) {
        console.error('[WebSocket] Erro ao conectar:', err);
      }
    };

    connect();

    // Cleanup
    return () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, []);

  const send = (data) => {
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(data));
    } else {
      console.warn('[WebSocket] Não conectado. Mensagem não enviada:', data);
    }
  };

  return { isConnected, send };
};

export default useWebSocket;
